<template>
  <div class="form-group" :class="{'input-group': hasIcon}">
    <slot name="label">
      <label v-if="label" class="control-label" :class="{ required: isRequired }">
        {{label}}
      </label>
      <img v-if="tooltip" v-tooltip="{content: tooltip, offset: 0}" src="@/assets/static/img/tooltip/tooltip.svg" alt="..."/>
    </slot>
    <slot name="addonLeft">
      <span v-if="addonLeftIcon" class="input-group-addon">
        <i :class="addonLeftIcon"></i>
      </span>
    </slot>
    <input
      :value="value"
      :maxlength="maxLength"
      @input="$emit('input',$event.target.value)"
      v-bind="$attrs"
      class="form-control"
      aria-describedby="addon-right addon-left">
    <slot></slot>
    <slot name="addonRight">
      <span v-if="addonRightIcon" class="input-group-addon">
        <i :class="addonRightIcon"></i>
      </span>
    </slot>
    <slot name="textLimit">
      <div v-if="maxLength" class="max-length">
        {{ remainingCount }}
      </div>
    </slot>
    <slot name="caption">
      <div v-if="hasCaption" class="caption">
        {{ caption }}
      </div>
    </slot>
  </div>
</template>
<script>
  export default {
    inheritAttrs: false,
    name: 'fg-input',
    props: {
      label: String,
      tooltip: String,
      value: [String, Number],
      maxLength: Number,
      isRequired: Boolean,
      addonRightIcon: String,
      addonLeftIcon: String,
      caption: String,
    },
    computed: {
      remainingCount () {
        return this.maxLength - this.value.length
      },
      hasIcon () {
        const {addonRight, addonLeft} = this.$slots
        return addonRight !== undefined || addonLeft !== undefined || this.addonRightIcon !== undefined || this.addonLeftIcon !== undefined
      },
      hasCaption () {
        return this.caption !== undefined;
      }
    },
    mounted: function () {
      // this.$nextTick(function() {
      //     $('[data-toggle="tooltip"]').tooltip()
      // })
    }
  }
</script>
<style>

</style>
